import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
// import { getToken } from '@/utils/auth'
// axios.defaults.withCredentials = true
var token=window.sessionStorage.getItem("token")
// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  withCredentials: true,
  crossDomain: true,
  headers: {
    tsltoken: token,
  },
  timeout: 30000 // 请求超时时间
})


export default service


// WEBPACK FOOTER //
// ./src/utils/request.js